import axios from 'axios';

import http from './composables/http';

import { useMyProfile } from './composables/useMyProfile';

var HOSTING = process.env.VUE_APP_BASE_URL;
console.log(`core base url =====> ${HOSTING}`);

axios.defaults.withCredentials = true;
export default {
    root : null,
    data: {
        Token: {},
        UserInfo: {},
        Business: {},
        Projects: [],

        Contractors: [],
        Categories: [],
        DisplayPage: 'Info', //Info or Project
        SelectedProject: {},
        PopupOptions: {},
        SelectedClientContract: {}, //for edit client contract
        SelectedSubContract: {}, //for edit sub contract
        SelectedCustomTerms: null,

        SelectedClient: null,
        
        IsFirstProject: false,
        ShowedFirstTimePopup: true,

        ShowedTemplatePopup: true,

        SelectedProjectAddress: '',

        ReminderMsg:'', //for payment reminder
 

        Provinces: ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon Territory']
    
    },
    HttpGet: function (url) {

        return http.request("get", url);
    },
    HttpPost: function (url, data) {

        return http.request("post", url, data);
    },
    HttpPostWithFile: function (url, data, fileKey, fileObj) {
        let _ = this.root.$loader.show(null, 30);
        var result = new Promise((resolve, reject) => {
            var formData = null;
            if (data instanceof FormData) {
                formData = data;
            } else {
                formData = new FormData();
                for (var key in data) {
                    let v = data[key];
                    if (Array.isArray(v)) { v.forEach(function (_v) { if (_v) { formData.append(key, _v); } }); }
                    else if (typeof v === 'object' && v) {
                        for (var k in v) {
                            formData.append(`${key}.${k}`, v[k]);
                        }
                    }
                    else { formData.append(key, v); }
                }
            }

            if (typeof fileObj == 'object') {
                formData.append(`${(fileKey === null || fileKey === undefined || fileKey == '') ? 'File' : fileKey}`, fileObj);
            }

            var config = { headers: { 'Content-type': 'multipart/form-data' }, withCredentials: true };
            axios.post(url, formData, config)
                .then(response => { resolve(response.data); })
                .catch(error => { reject(error); console.error(error); })
                .then(() => {
                    this.root.$loader.hide(_);
                });
        });
        return result;
    },
    setToken(data) {
        localStorage.setItem("token", JSON.stringify(data));
        this.data.Token = data;
        //console.log(data);
    },
    setBusiness(data) {
        localStorage.setItem("business", JSON.stringify(data));
        this.data.Business = data;
    },
    isTokenExpired() {
        const tokenData = this.data.Token;
        if (!tokenData || !tokenData.AccessExpires) return true;

        const now = Date.now();
        return now > tokenData.AccessExpires;
    },
    setTemplatePopup(data) {
        localStorage.setItem("FirstTemplatePopup", data);
        this.data.ShowedTemplatePopup = data;
    },
    getTemplatePopup() {
        let data = localStorage.getItem("FirstTemplatePopup") == 'false' ? false : true;
        this.data.ShowedTemplatePopup = data;

        return this.data.ShowedTemplatePopup;
    },
    
    setFirstTimeProjectPopup(data) {
        localStorage.setItem("FirstProjectPopup", data);
        this.data.ShowedFirstTimePopup = data;
    },
    getFirstTimeProjectPopup() {
        let data = localStorage.getItem("FirstProjectPopup") == 'false' ? false : true;
        this.data.ShowedFirstTimePopup = data;

        return this.data.ShowedFirstTimePopup;
    },

    setUserInfo(data) {
        localStorage.setItem("user", JSON.stringify(data));
        this.data.UserInfo = data;
        //console.log(data);
    },
    reloadUserInfo(callback) {
        window.$http.request('get', '/api/auth/userinfo').then((data) => {

            this.setUserInfo(data);
            //this.data.UserInfo.Metadata.IsRestricted = false;
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('refresh-subscription-status'));
            }, 500);

            if (callback && typeof callback === 'function') {  
                callback(data); 
            }
        })
    },
    loadStorage() {
        try {
            const user = localStorage.getItem("user");
            const token = localStorage.getItem("token");

            const Business = localStorage.getItem("business");

            Business ? this.data.Business = JSON.parse(Business) : {};

            if (user !== null) {
                this.data.UserInfo = JSON.parse(user);
            }

            if (token !== null) {
                this.data.Token = JSON.parse(token);
            }
        } catch (error) {
            console.error("Error loading data from localStorage:", error);
        }
    },
    clearStorage() {
        localStorage.clear();
        this.data.UserInfo = {};
    },
    captchaUrl: function (id) {
        return `${HOSTING}/api/common/captcha?id=${id}`;
    },

    //Project APIs ...
    GetProjectList: function (UserId) {

        var promise = new Promise(resolve => {
            var url = `${HOSTING}/api/app/project/readlist`;
            this.HttpGet(url).then(projectList => {
               
                for (var i = 0; i < projectList.Data.length; i++) {
                     
                    var project = projectList.Data[i];

                    var contracts = project.Contracts;

                    if (project.Clients.length>0) {
                        project.Client = project.Clients[0];//display the first client
                        project.Client.Contracts = [];
                        if (contracts) {
                            project.Client.Contracts = contracts.filter(m => m.Type == 1);
                        }
                    }
                    if (project.Subcontractors) {
                        for (var j = 0; j < project.Subcontractors.length; j++) {
                            var sub = project.Subcontractors[j];
                            sub.Contracts = [];

                            if (contracts) {
                                sub.Contracts = contracts.filter(m => m.Type == 0 && !!m.Parties?.find(p => p.DataId === sub.Id));
                            }
                        }

                    }
                }

                //console.log("Project=====> ", projectList);

                resolve(projectList);
                 

            });
        });

        return promise;
    },
    AddProject: function (data) {

        return http.request('post', '/api/app/project/create', data).then((res) => {
            if (res?.Type == 200) {
                window.$message.success('aaaaaaaaaaaa');

            }
        });
          
    },

    UpdateProjectStatus: function (_id, _status) {
        var data = { id: _id, status: _status };

        var promise = new Promise(resolve => {
            http.request('put', '/api/app/project/updatestatus', data).then((res) => {
                if (res?.Type == 200) {
                    window.$message.success('Updated');
                    resolve(res);

                }
            });

        });

        return promise;
    },

    EditProject: function (data) {
        data.UserId = this.data.UserInfo.UserId;
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/Projects/Edit`;
            this.HttpPost(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },


    //Contractor APIs...
    GetContractorList: function (id) {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/Subcontractors/List?projectId=` + id;
            //console.log(`GetContractorList ===>`, url);
            this.HttpGet(url).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },
    AddContractor: function (data) {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/Subcontractors/New`;
            this.HttpPost(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },
    EditContractor: function (data) {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/Subcontractors/Edit`;
            this.HttpPost(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },
    DeleteContractor: function (data) {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/Subcontractors/Delete`;
            this.HttpPost(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },

    //Category API
    GetCategoryList: function (data) { 
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/api/app/category/readlist`;
            this.HttpGet(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },

    //Service Type API
    GetServiceTypeList: function (data) {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/ServiceTypes/List`;
            this.HttpGet(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },

    //Client API
    EditClient: function (data) {
        //console.log(this.data.UserInfo);
        data.UserId = this.data.UserInfo.UserId;
        var promise = new Promise(resolve => {
            //console.log("Edit Clients");
            var url = `${HOSTING}/Clients/Edit`;
            this.HttpPost(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },

    //Terms API
    GetUserTerms: function() {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/Settings/TermsOfServices`;
            this.HttpGet(url).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },
    GetSubcontractorTerms: function () {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/api/app/term/readlist?type=1`;
            this.HttpGet(url).then(_data => {
                //console.log("GetSubcontractorTerms", _data);
                resolve(_data);
            });
        });

        return promise;
    },
    GetClientTerms: function () {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/api/app/term/readlist?type=0`;
            this.HttpGet(url).then(_data => {
                //console.log("GetClientTerms", _data);
                resolve(_data);
            });
        });

        return promise;
    },

    //Contract API
    GetContractList: function (UserId) {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/api/app/contract/readlist`;
            console.log(`GetContractList ===>`, url );
            this.HttpGet(url).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },
    PreviewContract: function (data) {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/Contracts/Preview`;
            this.HttpPost(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },
    MakeNewContract: function (data) {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/Contracts/New`;
            this.HttpPost(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },
    EditContract: function (data) {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/Contracts/Edit`;
            this.HttpPost(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },
    ResendContract: function (Id) {
        var data = { Id: Id };
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/Contracts/Resend`;
            this.HttpPost(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },
    CancelContract: function (Id) {
        var data = { Id: Id };
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/Contracts/Cancel`;
            this.HttpPost(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },
    GetContractByCode: function (code) {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/Contracts/Code?code=${code}&isEncrypt=true`;
            console.log(`GetContractByCode ===>`,url);
            this.HttpGet(url).then(_data => {
                resolve(_data);
            });
        });
        return promise;
    },
    SignedContractByCode: function (code, imageFile) {
        
        let postdata = new FormData();
        postdata.append("Code", code);
        postdata.append("PartyBSignature", imageFile);

        let promise = new Promise(resolve => {
            let url = `${HOSTING}/Contracts/Sign`;
            this.HttpPost(url, postdata).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },
    UploadContract: function (file, isConfirmed) {

        let url = `${HOSTING}/Barcode/ScanDocuments`;
        console.log("url ===>", url);
        let postdata = new FormData();
        postdata.append('file', file);
        postdata.append("userId", this.data.UserInfo.UserId);
        postdata.append('isConfirmed', isConfirmed);

        let promise = new Promise(resolve => {
            this.HttpPost(url, postdata).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },
    CheckHasContractToSign: function (key) {
        var _this = this;
        var promise = new Promise(resolve => {
            _this.GetContractByCode(key).then((data) => {
                if (data.Object != false) {
                    var contract = data.Object;
                    // need make sure the logic that how to link contract with partyB
                    if (contract.Signed == null
                        && (contract.PartyBId == _this.data.UserInfo.UserId || contract.PartyBEmail == _this.data.UserInfo.UserName)) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                } else {
                    resolve(false);
                }
            });
        });
        return promise;
        
    },

    //Payment
    SubscriptionWithStrip: function (UserId) {
        var data = { userId: UserId };
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/Payment/CreateCheckoutSession`;
            this.HttpPost(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },
    GetSession: function (SessionId) {
        var data = { sessionId: SessionId };
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/Payment/CheckoutSessionAsync`;
            this.HttpPost(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },
    ManagePayment: function (CustomerId) {
        var data = { customerId: CustomerId };
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/Payment/CustomerPortal`;
            this.HttpPost(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;

    },

    //custom terms...
    AddCustomTerms: function (data) {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/api/app/customterm/create`;
            this.HttpPost(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },

    
    EditCustomTerms: function (data) {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/api/app/customterm/update`;
            this.HttpPost(url, data).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },

    ListCustomTerms: function (userid) {
        var promise = new Promise(resolve => {
            var url = `${HOSTING}/api/app/customterm/readlist`;
            this.HttpGet(url).then(_data => {
                resolve(_data);
            });
        });

        return promise;
    },
};


